/**
 * Variant option tooltips.
 *
 * Shows the full option value in a small floating tooltip when the shopper
 * hovers (or keyboard-focuses) a variant option inside
 * `.wt-variant-options[data-tooltips]`.
 *
 * The tooltip is a single element appended to <body> and positioned with
 * `position: fixed`, so it is never clipped by an ancestor's `overflow: hidden`
 * (sticky product column, sliders, option bodies, etc.).
 *
 * Desktop / mouse only — disabled on touch and coarse pointers.
 */
(function () {
  if (window.__wtVariantTooltipInit) return;
  window.__wtVariantTooltipInit = true;

  var SELECTOR = '.wt-variant-options[data-tooltips] [data-tooltip]';
  var GAP = 10; // space between option and tooltip
  var MARGIN = 8; // min distance from viewport edge
  var tip = null;
  var current = null;

  function hoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function getTip() {
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'wt-variant-tooltip';
      tip.setAttribute('role', 'tooltip');
      document.body.appendChild(tip);
    }
    return tip;
  }

  function position(target) {
    var t = getTip();
    t.classList.remove('is-below');

    var r = target.getBoundingClientRect();
    var tw = t.offsetWidth;
    var th = t.offsetHeight;

    // Horizontal: centre on the option, then clamp inside the viewport.
    var left = r.left + r.width / 2 - tw / 2;
    left = Math.max(MARGIN, Math.min(left, window.innerWidth - tw - MARGIN));

    // Vertical: above the option; flip below if there isn't room.
    var top = r.top - th - GAP;
    if (top < MARGIN) {
      top = r.bottom + GAP;
      t.classList.add('is-below');
    }

    t.style.left = Math.round(left) + 'px';
    t.style.top = Math.round(top) + 'px';

    // Keep the arrow pointing at the option centre even after clamping.
    var arrow = r.left + r.width / 2 - left;
    t.style.setProperty('--arrow-left', Math.round(arrow) + 'px');
  }

  function show(target) {
    if (!hoverCapable()) return;
    var text = target.getAttribute('data-tooltip');
    if (!text) return;
    current = target;
    var t = getTip();
    t.textContent = text;
    position(target);
    t.classList.add('is-visible');
  }

  function hide() {
    current = null;
    if (tip) tip.classList.remove('is-visible');
  }

  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (link) show(link);
  });

  document.addEventListener('mouseout', function (e) {
    var link = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!link) return;
    // Ignore moves that stay within the same option.
    if (e.relatedTarget && link.contains(e.relatedTarget)) return;
    hide();
  });

  document.addEventListener('focusin', function (e) {
    var link = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (link) show(link);
  });

  document.addEventListener('focusout', function (e) {
    var link = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (link) hide();
  });

  // The tooltip is fixed to the viewport, so hide it when the page moves.
  window.addEventListener('scroll', hide, true);
  window.addEventListener('resize', hide);
})();
